export default __webpack_public_path__ + "static/pinecone-67fb03f2dfb8b5e8a4b2ddb6d103783a.png";